import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-65">
      <Header data-id="element-66" />
      <main className="flex-grow" data-id="element-67">{children}</main>
      <Footer data-id="element-68" />
    </div>;
};